var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3347 6.10504C12.6695 5.7702 12.6695 5.22642 12.3347 4.89158L8.04873 0.605622C7.71389 0.270782 7.17011 0.270782 6.83527 0.605622C6.50043 0.940462 6.50043 1.48424 6.83527 1.81908L9.66132 4.64245H1.44301C0.968872 4.64245 0.585815 5.02551 0.585815 5.49965C0.585815 5.97378 0.968872 6.35684 1.44301 6.35684H9.65864L6.83795 9.18021C6.50311 9.51505 6.50311 10.0588 6.83795 10.3937C7.17279 10.7285 7.71657 10.7285 8.05141 10.3937L12.3374 6.10772L12.3347 6.10504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightVector);
export default __webpack_public_path__ + "static/media/rightVector.e7255f5647adf5da915f091e7e36fdfd.svg";
export { ForwardRef as ReactComponent };